// extracted by mini-css-extract-plugin
module.exports = {"pagesSection":"jgp-11tE2","focus-visible":"jgp-2aE0-","pagesSectionRestrictWidth":"jgp-1bFED"};